import { useTranslation } from 'react-i18next';
import { Flex, Typography } from 'antd';
import classNames from 'classnames';
import { useGetClientInsuranceLink } from 'api/clients/use-get-client-insurance-link';
import { useDownloadFile } from 'shared/hooks/use-download-file';
import { formatDate } from 'shared/utils/time/format-date';
import { ClientInsurancePreview } from 'components/clients/client-insurance/components/client-insurance-preview';
import { ClientInsuranceStatus } from 'components/clients/client-insurance/components/client-insurance-status';
import { DeleteClientInsurance } from 'components/clients/client-insurance/components/delete-client-insurance';
import { EditClientInsuranceDates } from 'components/clients/client-insurance/components/edit-client-insurance-dates';
import styles from './client-insurance-history-item.module.scss';
import type { IClientInsuranceHistoryItemProps } from './types';

export const ClientInsuranceHistoryItem = (props: IClientInsuranceHistoryItemProps) => {
  const { clientId, insurance } = props;
  const { t } = useTranslation('client');

  const downloadFile = useDownloadFile();

  const { mutateAsync: getInsuranceLink } = useGetClientInsuranceLink();

  const handleDownload = async () => {
    const result = await getInsuranceLink({ clientId, insuranceId: insurance.id });
    downloadFile(result.url);
  };

  return (
    <Flex
      className={classNames(styles.item, { [styles.active]: insurance.status === 'active' })}
      align='center'
      gap={8}>
      <Flex className={styles.content} gap={2} vertical>
        <Flex className={styles.header} align='center' gap={8}>
          <ClientInsuranceStatus status={insurance.status} />
          <Typography.Text className={styles.dates} ellipsis>
            {insurance.validFrom} - {insurance.validTo}
          </Typography.Text>
        </Flex>
        <Typography.Link className={styles.fileName} ellipsis onClick={handleDownload}>
          {insurance.fileName}
        </Typography.Link>
        <Typography.Text className={styles.uploadedAt}>
          {t('insurance_uploaded_at', { date: formatDate(insurance.createdAt) })}
        </Typography.Text>
      </Flex>

      <Flex className={styles.actions} gap={6}>
        <ClientInsurancePreview
          clientId={clientId}
          insuranceId={insurance.id}
          fileName={insurance.fileName}
          mimeType={insurance.mimeType}
        />
        <EditClientInsuranceDates clientId={clientId} insurance={insurance} buttonLabel={null} />
        <DeleteClientInsurance clientId={clientId} insuranceId={insurance.id} />
      </Flex>
    </Flex>
  );
};
